import {Input} from '../../components/core/input'
import Textarea from '../../components/core/textarea'
import {SimpleBlueButton} from '../../components/core/button'
import ButtonLoader from '../../components/core/button/ButtonLoader'
import {Formik} from 'formik'
import {useEffect, useState, useRef} from 'react'
import CustomSelect from '../../components/core/customSelect'
import {rulesetSchema} from '../../utils/validation'
import {createRuleset, getRulesets, updateRuleset} from '../../stores/incident-management'
import {getStatuspages} from '../../stores/statuspage'
import StatuspageService from '../../api/statuspage'
import IncidentService from '../../api/incident'
import {useDispatch, useSelector} from 'react-redux'
import Customer from '../../utils/customer'
import {doNothing} from '../../utils/placeholder'
import Checkbox from '../../components/core/checkbox'
import {HelpIcon, SecondaryTrashIcon} from '../../icons'
import InputInfo from '../../components/core/inputInfo'
import useOnClickOutside from '../../utils/hooks/useOutsideClick'
import {useNavigate, useParams} from 'react-router-dom'
import {
    PageSubTitle,
    PageTitle,
    ResponsivePageTitle
} from '../../components/core/title'
import Tooltip from '../../components/core/tooltip'
import {colors} from '../../utils/colors'
import EnableWebhook from './EnableWebhook'
import Error from '../../components/core/error'
import {isNewFeatureEnabled} from '../../utils/newFeature'
import {getAllActiveMembers} from '../../stores/members'
import {getTeams} from '../../stores/teams'
import renderSkeletonLoaders from '../../utils/loader'
import classNames from 'classnames'
import {trimStringValues} from '../../utils/text'
import localStorageKeys from '../../utils/localStorageKeys'
import plans from '../../data/plans.json'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'
import Footer from '../../components/layouts/footer'

const names = {
    name: 'name',
    description: 'description',
    level: 'level',
    urgency: 'urgency',
    team_assignees: 'team_assignees',
    member_assignees: 'member_assignees',
    rule_type: 'rule_type',
    actions: 'actions',
    components: 'components',
    webhook_conditions: {
        key: 'key',
        operator: 'operator',
        value: 'value'
    },
    content_type: 'content_type'
}

const WEBHOOK_TYPE = 'webhook'
const JSON_TYPE = 'json-check'
const OTHER_INPUT = 'Content'
const MOBILE_WIDTH = 576

const CreateEditRuleset = () => {
    const {id} = useParams()
    const text = useNamespaceTranslations('rulesets')
    const conditionTypes = useNamespaceTranslations('condition-types')?.resource_conditions
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const formikRef = useRef()
    const rulesetsFormRef = useRef(null)
    const teamId = useSelector((state) => state.teams.selectedTeamId)
    const teams = useSelector(state => state.teams.teams)
    const isProcessing = useSelector(
        (state) => state.incident_management.isProcessing
    )
    const isFetching = useSelector(
        (state) => state.incident_management.isFetching
    )
    const statuspages = useSelector((state) => state.statuspage.statuspages)
    const rulesets = useSelector((state) => state.incident_management.rulesets)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const [active, setActive] = useState(null)
    const [allComponents, setAllComponents] = useState([])
    const [rulesetActions, setRulesetActions] = useState([])
    const [allMembers, setAllMembers] = useState([])
    const [isTypeWebhook, setIsTypeWebhook] = useState(false)
    const [hoveredKeyValue, setHoveredKeyValue] = useState(null)
    const [initialConditionOperator, setInitialConditionOperator] = useState([])
    const [focusedIndex, setFocusedIndex] = useState(-1)
    const [isInitializeEnabled, setIsInitializeEnabled] = useState(true)
    const plan = localStorage.getItem(localStorageKeys.PLAN)
    const ruleset = rulesets?.find((item) => item?.id === id)

    const actionsInfoRef = useRef(null)
    useOnClickOutside(actionsInfoRef, () =>
        setActive(active === names.actions && '')
    )

    const handleInfo = (index, state) => {
        state ? setActive(index) : setActive(null)
    }

    const teamAssigneesOptions = teams?.map(assignee => {
        return {
            label: assignee?.label,
            value: assignee?.value,
            type: 'team'
        }
    })

    const membersAssigneesOptions = allMembers?.map(assignee => {
        return {
            label: assignee?.label,
            value: assignee?.value,
            type: 'customer'
        }
    })

    const initialFormValues = {
        name: id ? ruleset?.name : '',
        description: id ? ruleset?.description : '',
        urgency: id ? text?.urgency_options?.find((urgency) => urgency?.value === ruleset?.urgency) : text?.urgency_options?.[0],
        team_assignees: id ? (ruleset?.assignees?.length > 0 ? ruleset?.assignees?.filter(item => item?.type === 'team')?.map(assignee => {
            return teamAssigneesOptions?.find(option => option?.value === assignee?.id)
        }).filter(Boolean) : []) : [teamAssigneesOptions?.find(option => option?.value === teamId)],
        member_assignees: id ? ruleset?.assignees?.length > 0 ? ruleset?.assignees?.filter(item => item?.type === 'customer')?.map(assignee => {
            return membersAssigneesOptions?.find(option => option?.value === assignee?.id)
        }).filter(Boolean) : [] : [],
        webhook_conditions: id && ruleset?.conditions?.length ? ruleset.conditions.map(condition => ({
            key: condition.key,
            value: condition.values?.[0],
            operator: initialConditionOperator?.find(item => item.value === condition.operator)
        })) : [{key: '', value: '', operator: initialConditionOperator[0]}],
        rule_type: id
            ? text?.type_options?.find((type) => type?.value === ruleset?.type)
            : text?.type_options?.[1],
        level: id
            ? text?.level_options?.find((level) => level?.value === ruleset?.level)
            : text?.level_options?.[1],
        content_type: id ? text.content_type_options.find(content => content?.value === ruleset?.conditions?.[0].type) : text.content_type_options[0],
        components: id
            ? rulesetActions?.length > 0
                ? rulesetActions
                    ?.filter(
                        (action) =>
                            action?.type ===
                text?.action_types_options?.trigger_statuspage_update
                    )
                    ?.map((action) => {
                        return action?.settings?.map((setting) => {
                            return allComponents?.find(
                                (component) => component?.value === setting?.target?.id
                            )
                        })
                    })
                    ?.reduce((accumulator, currentArray) => {
                        return accumulator.concat(currentArray)
                    }, []).filter(Boolean)
                : []
            : [],
        actions: id
            && rulesetActions?.length > 0
            ? rulesetActions?.map((action) => action?.type)
            : []
    }

    const createEditRuleset = (values, {setFieldError}) => {
        const teamAssignees = values?.team_assignees
        const memberAssignees = values?.member_assignees
        const allAssignees = (teamAssignees && memberAssignees) ? [...teamAssignees, ...memberAssignees] : (teamAssignees || memberAssignees || null)
        const payload = {
            name: values?.name,
            description: values?.description,
            rule_type: values?.rule_type.value,
            urgency: values?.urgency.value,
            assignees: allAssignees?.map(assignee => {
                return {
                    id: assignee?.value,
                    type: assignee?.type
                }
            }),
            level: values?.level.value,
            team_id: teamId,
            ...(values?.rule_type?.value === WEBHOOK_TYPE && values?.webhook_conditions?.length ?
                ({conditions: values.webhook_conditions.map(({key, value, operator}) => key || value || operator.value ?   trimStringValues({
                    key,
                    values: [value],
                    operator: operator.value,
                    type: values?.content_type?.value
                }) : null).filter(condition => condition !== null)})
                : {})
        }

        const filteredActions =
      values?.components?.length > 0
          ? values.actions
          : values.actions?.filter(
              (type) => type === text?.action_types_options?.trigger_alerts
          )
        const actions = {
            actions: filteredActions?.map((type) => {
                return type === text?.action_types_options?.trigger_alerts
                    ? {
                        type: type
                    }
                    : {
                        type: type,
                        settings: values?.components?.map((component) => {
                            return {
                                status_page_id: component?.statuspage_id,
                                component_id: component?.value
                            }
                        })
                    }
            })
        }
        id
            ? dispatch(updateRuleset(ruleset?.id, trimStringValues(payload), actions, setFieldError))
            : dispatch(createRuleset(trimStringValues(payload), actions, setFieldError, navigate))
    }

    const getStatuspagesComponents = async() => {
        try {
            const promises = statuspages?.map((statuspage) => {
                return StatuspageService.getStatuspageComponents(statuspage?.id)
            })
            const res = await Promise.all(promises)
            const components = res
                ?.map((item, index) => {
                    const data = item?.data?.data?.components?.filter(
                        (item) => item?.type === 'custom'
                    )
                    return data?.map((item) => {
                        return {
                            label: `${item?.name} (${statuspages?.[index]?.name})`,
                            value: item?.id,
                            statuspage_id: statuspages?.[index]?.id
                        }
                    })
                })
                .filter((item) => item?.length > 0)
            return components?.reduce((accumulator, currentArray) => {
                return accumulator.concat(currentArray)
            }, [])
        } catch (e) {
            doNothing()
        }
    }

    const getRulesetActions = async() => {
        try {
            const {data} = await IncidentService.getRulesetActions(ruleset?.id)
            setRulesetActions(data?.data?.actions)
        } catch (e) {
            doNothing()
        }
    }

    const getAllComponents = async() => {
        setAllComponents(await getStatuspagesComponents())
    }

    const getAllMembers = async() => {
        setAllMembers(await dispatch(getAllActiveMembers(teams)))
    }

    const handleActionChange = (actions, action, setFieldValue) => {
        actions?.includes(action)
            ? setFieldValue(
                names.actions,
                actions?.filter((type) => type !== action)
            )
            : setFieldValue(names.actions, actions.concat(action))
    }

    const handleContentTypeChange = (inputData, setFieldValue) => {
        setFieldValue(names.content_type, inputData)
        const updatedInitialConditionOperators = Object.values(inputData?.value === JSON_TYPE ? text.json_key_value_check.values : conditionTypes.keyword_value_check.values)

        setInitialConditionOperator(updatedInitialConditionOperators)
    }

    const handleInputChange = (index, field, value, showEmptyPair = true) => {
        const updatedConditions = formikRef?.current?.values?.webhook_conditions ?
            [...formikRef.current.values.webhook_conditions] : []

        updatedConditions[index][field] = value

        if (index === updatedConditions.length - 1 && showEmptyPair) {
            updatedConditions.push({key: '', operator: initialConditionOperator[0], value: ''})
        }

        formikRef?.current?.setValues({...formikRef?.current?.values, webhook_conditions: updatedConditions})
    }

    const handleRemove = (conditionIndex) => {
        const filteredConditions = formikRef?.current?.values?.webhook_conditions.filter((values, index) => index !== conditionIndex)
        formikRef?.current?.setValues({...formikRef?.current?.values, webhook_conditions: filteredConditions})
    }

    const handleFocus = (index) => {
        if (window.innerWidth > MOBILE_WIDTH) {
            setFocusedIndex(index)
            setIsInitializeEnabled(false)
        }
    }

    const handleBlur = () => {
        if (window.innerWidth > MOBILE_WIDTH) {
            setFocusedIndex(-1)
        }
    }

    const generateWebhookConditions = (values, errors) => {
        const options = values.content_type.value === JSON_TYPE ? text.json_key_value_check.values : conditionTypes.keyword_value_check.values
        const isJsonType = values.content_type.value === JSON_TYPE

        return (
            <div className='conditions-container'>
                {values?.webhook_conditions?.map((webhookPair, index) => (
                    <div className={classNames(`checker-container`, {
                        dark: isDarkMode,
                        'focused-container': index === focusedIndex
                    })} key={index}>
                        <div className={classNames('checker-wrapper', {
                            'focused-wrapper': hoveredKeyValue && index === values?.webhook_conditions?.length - 1
                        })}>
                            <Input
                                type="text"
                                value={isJsonType ? webhookPair.key : ''}
                                placeholder={isJsonType ? text.key : OTHER_INPUT}
                                inputIsDisabled={!isJsonType}
                                name={names.webhook_conditions.key}
                                error={errors.webhook_conditions?.[index]?.key}
                                onFocus={() => handleFocus(index)}
                                onBlur={handleBlur}
                                onChange={(e) => handleInputChange(index, names.webhook_conditions.key, e.target.value)}
                            />
                            <CustomSelect
                                options={Object.values(options)}
                                name={names.webhook_conditions.options}
                                placeholder={text.operator}
                                onChange={(_, data) => handleInputChange(index, names.webhook_conditions.operator, data)}
                                isClearable
                                error={errors.webhook_conditions?.[index]?.operator}
                                value={webhookPair.operator}
                            />
                            <Input
                                type="text"
                                value={webhookPair.value}
                                placeholder={text.value}
                                name={names.webhook_conditions.value}
                                error={errors.webhook_conditions?.[index]?.value}
                                onFocus={() => handleFocus(index)}
                                onBlur={handleBlur}
                                onChange={(e) => handleInputChange(index, names.webhook_conditions.value, e.target.value)}
                            />
                        </div>
                        {index === 0 ?
                            <Tooltip
                                placement="left"
                                trigger="click"
                                content={<span dangerouslySetInnerHTML={{__html: text.json_info}}/>}
                            >
                                <HelpIcon stroke={colors.colorBgFilter} width="22" height="22" />
                            </Tooltip> :
                            <span onClick={() => handleRemove(index)} className='remove-pairs'><SecondaryTrashIcon stroke={colors.colorRed}/></span>}
                    </div>
                ))}
                {typeof errors?.webhook_conditions === 'string' && <Error hasIcon error={errors?.webhook_conditions}/>}
            </div>
        )
    }

    useEffect(() => {
        if (statuspages?.length > 0) {
            getAllComponents()
        }
    }, [statuspages])

    useEffect(() => {
        dispatch(getRulesets(true))
        dispatch(getStatuspages())
        dispatch(getTeams())
    }, [])

    useEffect(() => {
        ruleset?.id && getRulesetActions()
    }, [ruleset])

    useEffect(() => {
        getAllMembers()
    }, [teams])

    useEffect(() => {
        setIsInitializeEnabled(true)
    }, [rulesets])

    useEffect(() => {
        if (formikRef?.current &&  formikRef?.current?.values?.rule_type?.value === WEBHOOK_TYPE) {
            setIsTypeWebhook(true)
            setInitialConditionOperator(Object.values(formikRef?.current?.values?.content_type?.value === JSON_TYPE ? text.json_key_value_check.values : conditionTypes.keyword_value_check.values))
        }
    }, [formikRef?.current?.values.rule_type, formikRef?.current?.values.content_type])

    useEffect(() => {
        const updatedConditions = formikRef?.current?.values?.webhook_conditions.map(condition => ({
            ...condition,
            operator: initialConditionOperator[0]
        }))

        formikRef?.current?.setValues({...formikRef?.current?.values, webhook_conditions: updatedConditions})
    }, [initialConditionOperator])

    useEffect(() => {
        const {values, setValues} = formikRef?.current || {}
        const conditions = values?.webhook_conditions || []
        const hasValidConditions =
            ruleset?.id &&
            conditions.length === ruleset?.conditions?.length &&
            !conditions.some(({key, value}) => key === '' || value === '') &&
            focusedIndex === -1

        if (hasValidConditions) {
            conditions.push({key: '', operator: initialConditionOperator[0], value: ''})
            setValues({
                ...values,
                webhook_conditions: conditions
            })
        }

        const lastConditionIndex = conditions.length - 1
        const lastCondition = ruleset?.conditions?.[lastConditionIndex] || {}
        const key = hoveredKeyValue?.key?.toString() || lastCondition.key || ''
        const value = hoveredKeyValue?.value?.toString() || lastCondition.values?.[0] || ''
        const isClicked = !!hoveredKeyValue?.clicked

        handleInputChange(lastConditionIndex, names.webhook_conditions.key, key, isClicked)
        handleInputChange(lastConditionIndex, names.webhook_conditions.value, value, isClicked)
    }, [hoveredKeyValue])

    const isDisabled = plan === plans.free_v2.key

    return (
        <main className={classNames('main create-ruleset', {
            dark: isDarkMode
        })}>
            <div>
                <ResponsivePageTitle />
                <div className="content-title">
                    <div className="left-side">
                        <div>
                            <PageSubTitle>
                                <p className={classNames('section', {
                                    dark: isDarkMode
                                })}>{text.section}</p>
                            </PageSubTitle>
                            <PageTitle>
                                <h1  className={classNames('page-title', {
                                    dark: isDarkMode
                                })}>{id ? text.edit_ruleset : text.add_ruleset}</h1>
                            </PageTitle>
                        </div>
                    </div>
                </div>
                <div className={classNames('rulesets-container', {
                    dark: isDarkMode
                })}>
                    <Formik
                        initialValues={initialFormValues}
                        enableReinitialize={isInitializeEnabled}
                        innerRef={formikRef}
                        onSubmit={createEditRuleset}
                        validationSchema={rulesetSchema}
                        validateOnBlur={false}
                        validateOnChange={false}
                    >
                        {({errors, handleSubmit, setFieldValue, handleChange, values}) => (
                            <form onSubmit={handleSubmit} className="rulesets-form" ref={rulesetsFormRef}>
                                {isFetching ? <span className="events-loader">{renderSkeletonLoaders(16)}</span> :
                                    <>
                                        <span className="ruleset-details">{text.ruleset_details}</span>
                                        <Input
                                            name={names.name}
                                            value={values.name}
                                            error={errors.name}
                                            inputIsDisabled={isDisabled}
                                            placeholder={text.name_placeholder}
                                            infoText={text.name_info}
                                            onChange={handleChange}
                                            activeInfo={active === names.name}
                                            handleInfo={(state) => handleInfo(names.name, state)}
                                        />
                                        <Textarea
                                            name={names.description}
                                            value={values.description}
                                            isDisabled={isDisabled}
                                            error={errors.description}
                                            placeholder={text.description_placeholder}
                                            infoText={text.description_info}
                                            onChange={handleChange}
                                            activeInfo={active === names.description}
                                            handleInfo={(state) => handleInfo(names.description, state)}
                                        />
                                        {isNewFeatureEnabled() && <CustomSelect
                                            name={names.level}
                                            value={values.level}
                                            isDisabled={isDisabled}
                                            onChange={(name, data) => {
                                                setFieldValue(name, data)
                                                if (data?.value === 'organisation') {
                                                    setFieldValue(
                                                        names.action_type,
                                                        id ? values.action_type : []
                                                    )
                                                }
                                            }}
                                            placeholder={text.level_placeholder}
                                            infoText={text.level_info}
                                            options={
                                                Customer.isRoot()
                                                    ? text.level_options
                                                    : text.level_options?.slice(0, -1)
                                            }
                                            activeInfo={active === names.level}
                                            handleInfo={(state) => handleInfo(names.level, state)}
                                            error={errors.level}
                                        />}
                                        <CustomSelect
                                            name={names.urgency}
                                            value={values.urgency}
                                            onChange={setFieldValue}
                                            isDisabled={isDisabled}
                                            placeholder={text.urgency_placeholder}
                                            infoText={text.urgency_info}
                                            options={text.urgency_options}
                                            activeInfo={active === names.urgency}
                                            handleInfo={(state) => handleInfo(names.urgency, state)}
                                            error={errors.urgency}
                                        />
                                        <CustomSelect
                                            name={names.team_assignees}
                                            value={values.team_assignees}
                                            isDisabled={isDisabled}
                                            onChange={setFieldValue}
                                            placeholder={text.team_assignees_placeholder}
                                            infoText={text.team_assignees_info}
                                            options={teamAssigneesOptions}
                                            activeInfo={active === names.team_assignees}
                                            handleInfo={(state) => handleInfo(names.team_assignees, state)}
                                            error={errors.team_assignees}
                                            isMulti
                                        />
                                        {isNewFeatureEnabled() && (
                                            <CustomSelect
                                                name={names.member_assignees}
                                                value={values.member_assignees}
                                                isDisabled={isDisabled}
                                                onChange={setFieldValue}
                                                placeholder={text.member_assignees_placeholder}
                                                infoText={text.member_assignees_info}
                                                options={membersAssigneesOptions}
                                                activeInfo={active === names.member_assignees}
                                                handleInfo={(state) => handleInfo(names.member_assignees, state)}
                                                error={errors.member_assignees}
                                                isMulti
                                            />
                                        )}
                                        {isNewFeatureEnabled() && <CustomSelect
                                            name={names.rule_type}
                                            isDisabled={isDisabled}
                                            value={values.rule_type}
                                            onChange={(name, data) => {
                                                setIsTypeWebhook(data?.value === WEBHOOK_TYPE)
                                                setFieldValue(names.rule_type, data)
                                            }}
                                            placeholder={text.type_placeholder}
                                            infoText={text.type_info}
                                            options={text.type_options}
                                            activeInfo={active === names.rule_type}
                                            handleInfo={(state) => handleInfo(names.rule_type, state)}
                                            error={errors.rule_type}
                                        />}
                                        {values.rule_type?.value === WEBHOOK_TYPE &&
                                <>
                                    <CustomSelect
                                        name={names.content_type}
                                        isDisabled={isDisabled}
                                        value={values.content_type}
                                        onChange={(name, data) => handleContentTypeChange(data, setFieldValue)}
                                        placeholder={text.content_type_placeholder}
                                        infoText={text.content_type_info}
                                        options={text.content_type_options}
                                        activeInfo={active === names.content_type}
                                        handleInfo={(state) => handleInfo(names.content_type, state)}
                                        error={errors.content_type}
                                    />
                                    {generateWebhookConditions(values, errors)}
                                </>}
                                        <div  className={classNames('actions', {
                                            dark: isDarkMode
                                        })}>
                                            <div className="actions-header">
                                                <h4>{text.action_type_placeholder}</h4>
                                                <div
                                                    ref={actionsInfoRef}
                                                    className={`help ${
                                                        active === names.actions ? 'active' : ''
                                                    }`}
                                                    onClick={() =>
                                                        setActive(active === names.actions ? '' : names.actions)
                                                    }
                                                >
                                                    <span>
                                                        <HelpIcon />
                                                    </span>
                                                    <InputInfo text={text.action_type_info} />
                                                </div>
                                            </div>
                                            <Checkbox
                                                label={text.trigger_alerts}
                                                disabled={isDisabled}
                                                onChange={() =>
                                                    handleActionChange(
                                                        values.actions,
                                                        text?.action_types_options?.trigger_alerts,
                                                        setFieldValue
                                                    )
                                                }
                                                type="checkbox"
                                                checked={values.actions?.includes(
                                                    text?.action_types_options?.trigger_alerts
                                                )}
                                            />
                                            <Checkbox
                                                label={text.trigger_statuspage_update}
                                                disabled={isDisabled}
                                                onChange={() =>
                                                    handleActionChange(
                                                        values.actions,
                                                        text?.action_types_options?.trigger_statuspage_update,
                                                        setFieldValue
                                                    )
                                                }
                                                type="checkbox"
                                                checked={values.actions?.includes(
                                                    text?.action_types_options?.trigger_statuspage_update
                                                )}
                                            />
                                        </div>
                                        {values.actions?.includes(
                                            text?.action_types_options?.trigger_statuspage_update
                                        ) && (
                                            <>
                                                <CustomSelect
                                                    name={names.components}
                                                    isDisabled={isDisabled}
                                                    value={values.components}
                                                    options={allComponents}
                                                    placeholder={text.components_placeholder}
                                                    infoText={text.components_info}
                                                    activeInfo={active === names.components}
                                                    handleInfo={(state) => handleInfo(names.components, state)}
                                                    onChange={setFieldValue}
                                                    error={errors.components}
                                                    isMulti
                                                />
                                            </>
                                        )}
                                        <SimpleBlueButton type="submit" disabled={isProcessing || isDisabled}>
                                            {isProcessing && <ButtonLoader />}
                                            {text.submit}
                                        </SimpleBlueButton>
                                    </>}
                            </form>
                        )}
                    </Formik>
                    {isTypeWebhook && <EnableWebhook setHoveredKeyValue={setHoveredKeyValue} formikRef={formikRef} rulesetsFormRef={rulesetsFormRef} isDarkMode={isDarkMode} noPlan={isDisabled}/>}
                </div>
            </div>
            <Footer />
        </main>
    )
}

export default CreateEditRuleset
